"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsClient = exports.DEFAULT_HOST = void 0;
const tslib_1 = require("tslib");
const api_requestor2_1 = require("@madbox/api_requestor2");
exports.DEFAULT_HOST = 'https://notifications-api.madbox.io';
class NotificationsClient {
    constructor(host = exports.DEFAULT_HOST, apiRequestor) {
        this.host = host;
        this.apiRequestor = apiRequestor || api_requestor2_1.ApiRequestor2.instance;
    }
    static get instance() {
        if (!NotificationsClient._instance) {
            NotificationsClient._instance = new NotificationsClient();
        }
        return NotificationsClient._instance;
    }
    static init(host = exports.DEFAULT_HOST, apiRequestor) {
        const instance = new NotificationsClient(host, apiRequestor);
        if (!NotificationsClient._instance) {
            NotificationsClient._instance = instance;
        }
        return instance;
    }
    getNotifications(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRequestor.get(this.host + '/notifications', {
                params,
            });
            return response.data;
        });
    }
    updateNotification(params, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { _id } = params, rest = tslib_1.__rest(params, ["_id"]);
            const url = this.host + '/notifications/' + _id;
            if (options === null || options === void 0 ? void 0 : options.beacon) {
                return navigator.sendBeacon(url + '?token=' + this.apiRequestor.getToken(), JSON.stringify(rest));
            }
            const response = yield this.apiRequestor.post(url, Object.assign({}, rest));
            return response.data.updated;
        });
    }
}
exports.NotificationsClient = NotificationsClient;
//# sourceMappingURL=index.js.map